import React from "react";

export const TodosContext = React.createContext();
